import { createContext } from "react";
import { Event } from "../dto/Event";

export interface EventContextInterface 
{
    event: Event;
    id: string;
}

export default createContext<EventContextInterface>({ event: null, id: null });